var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMagnifyingGlass = function SvgMagnifyingGlass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Magnifying-Glass_svg__clip0_50854_41362)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B4EEF3",
    d: "M18.215 3.162c8.077 0 14.625 6.547 14.625 14.625s-6.548 14.625-14.625 14.625S3.59 25.864 3.59 17.787 10.137 3.162 18.215 3.162"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F04B24",
    d: "M28.851 28.917a2.87 2.87 0 0 1-4.057 0l-6.151-6.15 1.996-1.997s.097.065.146.081c4.642 2.467 8.066 8.066 8.066 8.066"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DE3719",
    d: "m22.714 18.724 6.152 6.151a2.87 2.87 0 0 1 0 4.058l-8.18-8.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DEFAFF",
    d: "M20.174 8.07a8.61 8.61 0 0 1 0 12.173c-3.36 3.36-8.796 3.344-12.156-.016s-3.36-8.813-.016-12.156a8.61 8.61 0 0 1 12.172 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4EEF3",
    d: "M20.172 8.066a8.61 8.61 0 0 1 0 12.172L8.016 8.082a8.61 8.61 0 0 1 12.172 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003E52",
    d: "M7.028 7.115c-3.88 3.88-3.88 10.177 0 14.056s10.176 3.879 14.055 0 3.879-10.177 0-14.056-10.176-3.879-14.055 0m12.156 12.157c-2.824 2.824-7.433 2.824-10.257 0s-2.824-7.434 0-10.258 7.433-2.824 10.257 0 2.824 7.434 0 10.258"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003E52",
    d: "M21.114 7.126c3.879 3.879 3.879 10.176 0 14.055l-1.9-1.899c2.825-2.824 2.825-7.433 0-10.257-2.823-2.824-7.432-2.824-10.256 0l-1.9-1.899c3.88-3.879 10.177-3.879 14.056 0"
  }))));
};
export default SvgMagnifyingGlass;